import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Snackbar,
  CircularProgress
} from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';
import { forgotPassword } from '../../Conections/LogConections';
import { useNavigate } from 'react-router-dom';


export default function ForgotPassword() {
  
  const goTo = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setSnackbarMessage('Por favor, ingrese su correo electrónico.');
      setOpenSnackbar(true);
      return;
    }

    setIsLoading(true);

    // Simulamos una llamada a la API
    try {
      const response = await forgotPassword(email);
      setSnackbarMessage('Se ha enviado un enlace de restablecimiento a su correo electrónico.');
      setOpenSnackbar(true);
      setEmail('');
      if (response !== 403 && response !== 500) {
        setSnackbarMessage('Se ha enviado un enlace de restablecimiento a su correo electrónico.');
        setOpenSnackbar(true);
        setEmail('');
        goTo("/login");
      }
      else {
        setSnackbarMessage('Hubo un error al procesar su solicitud. Por favor, intente nuevamente.');
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage('Hubo un error al procesar su solicitud. Por favor, intente nuevamente.');
      setOpenSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default'
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: '100%' }}>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            ¿Olvidaste tu contraseña?
          </Typography>
          <Typography variant="body2" align="center" sx={{ mb: 3 }}>
            Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
          </Typography>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: <EmailIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Enviar enlace de restablecimiento'}
          </Button>
        </Box>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
      />
    </Box>
  );
}